import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";
import { Copy, WhatsappLogo, InstagramLogo, FacebookLogo, TiktokLogo, ShieldCheck } from "@phosphor-icons/react";

const CHANNELS = [
  { key: "whatsapp", icon: WhatsappLogo, color: "#25D366" },
  { key: "instagram", icon: InstagramLogo, color: "#E1306C" },
  { key: "facebook", icon: FacebookLogo, color: "#1877F2" },
  { key: "tiktok", icon: TiktokLogo, color: "#0b1521" },
  { key: "guidelines", icon: ShieldCheck, color: "#0d3b66" },
];

export default function Academy() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("whatsapp");

  useEffect(() => {
    api.get("/academy").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = items.filter((i) => i.channel === active);

  const copy = async (txt) => {
    await navigator.clipboard.writeText(txt);
    toast.success(t.academy.copied);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif-display text-4xl">{t.academy.title}</h1>
        <p className="text-[#3b4b5a] mt-2 max-w-2xl">{t.academy.sub}</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {CHANNELS.map((c) => (
          <button
            key={c.key}
            data-testid={`academy-tab-${c.key}`}
            onClick={() => setActive(c.key)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border ${
              active === c.key ? "bg-[#0d3b66] text-[#f4a261] border-[#0d3b66]" : "bg-white border-[#e6dfd2] hover:border-[#0d3b66]/30"
            }`}
          >
            <c.icon size={16} weight="fill" color={active === c.key ? "#f4a261" : c.color} />
            {t.academy[c.key]}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="p-12 text-center text-sm text-[#6b7280] rounded-3xl bg-white border border-[#e6dfd2]">No content yet.</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {filtered.map((item) => (
            <div key={item.id} data-testid={`academy-item-${item.id}`} className="rounded-3xl bg-white border border-[#e6dfd2] p-6 card-lift">
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#6b7280]">{item.kind}</div>
                  <h3 className="font-serif-display text-2xl mt-2">{lang === "tr" ? item.title_tr : item.title_en}</h3>
                </div>
                {item.channel !== "guidelines" && (
                  <button data-testid={`copy-content-${item.id}`} onClick={() => copy(lang === "tr" ? item.body_tr : item.body_en)} className="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-[#e6dfd2] text-xs hover:border-[#0d3b66]">
                    <Copy size={12} /> {t.academy.copy}
                  </button>
                )}
              </div>
              <p className="mt-4 text-sm text-[#3b4b5a] leading-relaxed whitespace-pre-wrap">{lang === "tr" ? item.body_tr : item.body_en}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
